// extracted by mini-css-extract-plugin
module.exports = {"root":"DiscountBanner_root__1tsSX","iconDiscount":"DiscountBanner_iconDiscount__wfU9b","text":"DiscountBanner_text__JiBLT"};